import { CateringChefMenuItem, CateringOrderChef } from 'types/chefs/menuitems'

/**
 * Count menu items from the chefs array structure.
 * Counts orderMenuItems + customOrderMenuItems, including child items.
 */
export const getMenuItemCountFromChefs = (chefs: CateringOrderChef[]) => {
  return (chefs || []).reduce((total, chef) => {
    const allItems = [
      ...(chef.orderMenuItems || []),
      ...(chef.customOrderMenuItems || []),
    ]

    return (
      total +
      allItems.reduce((count, item) => {
        return count + 1 + (item.childItems?.length || 0)
      }, 0)
    )
  }, 0)
}

/**
 * Count menu items from a flat proposalMenuItems array.
 * This array already contains both parent and child items as separate entries.
 */
export const getMenuItemCountFromFlat = (menuItems: CateringChefMenuItem[]) => {
  return (menuItems || []).length
}
